import { Reveal, Eyebrow } from "@/components/Reveal";
import { MANIFESTO_CHAPTERS, IMAGES } from "@/data/content";

const TINTS = {
  mauve: "bg-mauve-light text-mauve-dark",
  navy: "bg-greige text-navy",
  gold: "bg-gold-light text-gold-dark",
  sage: "bg-sage-light text-sage-dark",
};

const NUM_TINTS = {
  mauve: "text-mauve",
  navy: "text-navy/25",
  gold: "text-gold",
  sage: "text-sage-dark/60",
};

export const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="relative py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Eyebrow>Our Core Belief</Eyebrow>
              <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-navy sm:text-3xl lg:text-4xl">
                Why Adeya Companions is fundamentally different
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-charcoal/75">
                We do not provide personal care or medical services. Our focus is
                meaningful human connection, emotional wellbeing, and helping people
                maintain their independence — gently, and on their own terms.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-10 hidden lg:block">
              <div className="relative w-64">
                <div className="overflow-hidden rounded-3xl shadow-elevated ring-1 ring-navy/10">
                  <img
                    src={IMAGES.reading}
                    alt="An elderly woman smiling peacefully while reading in warm living-room light"
                    className="aspect-[4/5] w-full object-cover"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div
                  aria-hidden="true"
                  className="absolute -bottom-4 -right-4 -z-10 h-full w-full rounded-3xl bg-gold-light"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="divide-y divide-navy/[0.08]">
            {MANIFESTO_CHAPTERS.map((chapter, i) => {
              const Icon = chapter.icon;
              return (
                <Reveal key={chapter.number} delay={i * 0.08}>
                  <li
                    data-testid={`manifesto-chapter-${chapter.number}`}
                    className="group flex gap-6 py-10 transition-colors duration-300 sm:gap-10"
                  >
                    <span
                      aria-hidden="true"
                      className={`font-serif text-5xl font-medium leading-none sm:text-6xl ${NUM_TINTS[chapter.tint]}`}
                    >
                      {chapter.number}
                    </span>
                    <div>
                      <div className="flex flex-wrap items-center gap-3">
                        <span
                          className={`flex h-10 w-10 items-center justify-center rounded-xl ${TINTS[chapter.tint]}`}
                        >
                          <Icon className="h-5 w-5" aria-hidden="true" />
                        </span>
                        <h3 className="font-serif text-xl text-navy sm:text-2xl">{chapter.pillar}</h3>
                      </div>
                      <p className="mt-2 font-mono text-[0.65rem] font-semibold uppercase tracking-[0.25em] text-mauve">
                        {chapter.tagline}
                      </p>
                      <p className="mt-3 max-w-lg text-sm leading-relaxed text-charcoal/75 sm:text-base">
                        {chapter.description}
                      </p>
                    </div>
                  </li>
                </Reveal>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  </section>
);
